import { useState, useEffect } from 'react';
import { client as apollo } from 'cccisd-apollo';
import pdProjectIdQuery from './pdProjectIdQuery.graphql';

const PRODUCTION_PROJECT_ID = 71;
let cachedProjectId = null;

// Get projectId for "PD Supplements" project. If there is no project with "PD Supplements" label then return 71 (projectId on production)
const usePdProjectId = () => {
    const [projectId, setProjectId] = useState(cachedProjectId);

    useEffect(() => {
        if (cachedProjectId) {
            return;
        }

        (async () => {
            const result = await apollo.query({
                query: pdProjectIdQuery,
                fetchPolicy: 'network-only',
            });

            const id = result.data.groups.questproject.group.groupId || PRODUCTION_PROJECT_ID;
            setProjectId(id);
            cachedProjectId = id;
        })();
    }, []);

    const loading = !projectId;

    return [projectId, loading];
};

export default usePdProjectId;
